<!-- Copyright (c) 2025 MOCA Systems, Inc. All rights reserved. -->

<div mat-dialog-content class="image-container">
	<img [src]="data.imageUrl" [alt]="data.altText || 'Image Preview'" />
</div>
<button mat-icon-button class="close-button" (click)="close()" aria-label="Close">
	<mat-icon>close</mat-icon>
</button>
